import { KnockTypes } from '../Knock/KnockTypes'
import TextFilter from './TextFilter'
import DecimalFilter from './DecimalFilter'
import NumberFilter from './NumberFilter'
import BooleanFilter from './BooleanFilter'
import DateFilter from './DateFilter'
import RegistrationFilter from './RegistrationFilter'

const KnockTypeFilterMap = {
  [KnockTypes.String]: TextFilter,
  [KnockTypes.Money]: DecimalFilter,
  [KnockTypes.Decimal]: DecimalFilter,
  [KnockTypes.Number]: NumberFilter,
  [KnockTypes.Boolean]: BooleanFilter,
  [KnockTypes.Date]: DateFilter,
  [KnockTypes.DateTime]: DateFilter,
  [KnockTypes.Registration]: RegistrationFilter,
  [KnockTypes.EmailAddress]: TextFilter,
  [KnockTypes.PhoneNumber]: TextFilter,
  [KnockTypes.ShopID]: TextFilter,
  [KnockTypes.VIN]: TextFilter
}

export default KnockTypeFilterMap
